import { React, useState, useEffect } from "react";
import LoginProcess from "./loginProcess";
import { loadStripe } from "@stripe/stripe-js";
import {
  PaymentElement,
  Elements,
  useStripe,
  useElements,
} from "@stripe/react-stripe-js";
import { authFetch, getAuthInfo, redirectToLogin } from "./authFetch";

function BuyProcess(props) {
  const [stage, setStage] = useState(
    sessionStorage.getItem("userinfo") === null ? props.stage : 2
  );
  const [wallet, setWallet] = useState("");
  const [hideNav, setHideNav] = useState({ left: false, right: false });
  const [afterSale, setAfterSale] = useState({ newprice: 0, forsale: 0 });
  const [europe, setEurope] = useState(-1);
  const [name, setName] = useState("");
  const [vat, setVat] = useState("");
  const [message, setMessage] = useState("");
    const [err, setErr] = useState("");

  const paymentGW = process.env.REACT_APP_PAYMENTGATEWAY_END_POINT;
 //const intentGW = process.env.REACT_APP_PAYMENTGATEWAY;
  const intentGW = process.env.REACT_APP_GATEWAY
  console.log(intentGW)

  console.log(process.env);
  
  const { idea } = props;

  const openInSameTab = (url) => {
    window.open(url, "_self", "noopener,noreferrer");
  };

  function ownWallet() {
    setWallet(process.env.REACT_APP_OWNWALLET);
    var buyInfo = JSON.parse(sessionStorage.getItem("buyInfo"));
    var m = JSON.stringify({
      phraseData: buyInfo.phraseData,
      BuyerUserId: buyInfo.BuyerUserId, // userId that buys
      sellerUserId: buyInfo.sellerUserId, // userId that sells
      phraseId: buyInfo.phraseId, //phrase
      wallet: process.env.REACT_APP_OWNWALLET, //wallet
      forsale: buyInfo.forsale, //boolen with the intention
      price: buyInfo.price, //integer with the new price
    });
    sessionStorage.setItem("buyInfo", m);

    setHideNav({ left: hideNav.left, right: true });
  }

  async function ConnectToWallet(setWallet) {
    if (typeof window.ethereum !== "undefined") {
      // Do something
      window.ethereum
        .request({ method: "eth_requestAccounts" })
        .then(function (res) {
          // Return the address of the wallet
          console.log(res);
          setWallet(res[0]);
         

          var buyInfo = JSON.parse(sessionStorage.getItem("buyInfo"));
          buyInfo.wallet = res[0];
          sessionStorage.setItem("buyInfo", JSON.stringify(buyInfo));
          
        });

      window.ethereum.on("accountsChanged", handleAccountsChanged);

      function handleAccountsChanged(accounts) {
        if (accounts.length === 0) {
          setWallet("");
        }
      }
    } else {
      
    }
  }

  useEffect(() => {
    if (wallet !== "") {
      sessionStorage.setItem("wallet", wallet);
    } else {
      sessionStorage.removeItem("wallet");
    }
  }, [wallet]);

  function WalletConnectDivs() {
    return (
      <div className="newOptions_class">
        {wallet ? (
          <span>
            {wallet === process.env.REACT_APP_OWNWALLET ? (
              <div className="text-xl">
                You are connected to the Hyperwallet
                <br />
                <br />
                (that is our wallet where we hold your tokens on your behalf)
                <br />
                <br />
                <span
                  onMouseDown={() => {
                    setWallet("");
                    sessionStorage.removeItem("wallet");
                    setHideNav({ left: hideNav.left, right: false });
                  }}
                  className="mouse2 colorWallet"
                >
                  Disconnect
                </span>
              </div>
            ) : (
              <div className="text-xl">
                You are connected to your wallet <br /> {wallet} <br />{" "}
                <span
                  onMouseDown={() => {
                    setWallet("");
                    sessionStorage.removeItem("wallet");
                    setHideNav({ left: hideNav.left, right: false });
                  }}
                  className="mouse2 colorWallet"
                >
                  Disconnect
                </span>
              </div>
            )}
          </span>
        ) : (
          <span>
            <span
              className="text-xl mouse2 selected"
              onMouseDown={() => {
                ConnectToWallet(setWallet);
              }}
            >
              [ Your Wallet ]
            </span>
            <br />
            <span className="text-xl ">or</span>
            <br />
            <span
              className="text-xl mouse2 selected"
              onMouseDown={() => {
                ownWallet();
              }}
            >
              [ HyperWallet ]
            </span>
          </span>
        )}
      </div>
    );
  }

  function Stage2() {
    useEffect(() => {
      if (!hideNav.right) setHideNav({ left: false, right: true });

      // Check if user is trying to buy their own idea
      const buyInfo = JSON.parse(sessionStorage.getItem("buyInfo"));
      const userinfo = JSON.parse(sessionStorage.getItem("userinfo"));

      // Log owner ID and user ID for debugging
      console.log("Owner ID (sellerUserId):", buyInfo?.sellerUserId);
      console.log("User ID (buyer):", userinfo?.id);

      if (buyInfo && userinfo && buyInfo.sellerUserId === userinfo.id) {
        alert("You cannot buy your own idea!");
        window.location.assign("/");
      }
    }, []);

    return <WalletConnectDivs />;
  }

  const isEmpty = (str) => {
    return !str || !str.trim().length;
  };

  const validateAndNext = async () => {
    if (isEmpty(name)) {
      setMessage("We need a name");
      setTimeout(() => setMessage(""), 1500);
      return;
    }

   

    setStage(3);
  };


  function logout() {
    sessionStorage.removeItem("userinfo");
    sessionStorage.removeItem("wallet");
    setStage(1);
  }

  const CheckoutForm = (props) => {
    const stripe = useStripe();
    const elements = useElements();

    const [errorMessage, setErrorMessage] = useState(null);
    const [Loading, setLoading] = useState(0);
    const [isProcessing, setIsProcessing] = useState(false);

    const handleSubmit = async (event) => {
      //event.preventDefault();

      // Prevent multiple submissions
      if (isProcessing) {
        return;
      }

      setIsProcessing(true);
      setLoading(1);

      if (elements == null) {
        setLoading(0);
        setIsProcessing(false);
        return;
      }

      if (stripe == null) {
        setLoading(0);
        setIsProcessing(false);
        return;
      }

      // Trigger form validation and wallet collection
      const { error: submitError } = await elements.submit();
      if (submitError) {
        // Show error to your customer
        setErrorMessage(submitError.message);
        setLoading(0);
        setIsProcessing(false);
        return;
      }

      // Get the payment element to check if it's complete
      const paymentElement = elements.getElement('payment');
      if (!paymentElement) {
        setErrorMessage("Payment element not ready");
        setLoading(0);
        setIsProcessing(false);
        return;
      }

      elements.on("ready", () => {});

      var buyinfo = JSON.parse(sessionStorage.getItem("buyInfo"));
      var userinfo = JSON.parse(sessionStorage.getItem("userinfo"));

      // Add tax metadata
      var totals = props.totals;
      buyinfo.name = name;
      buyinfo.vat = vat;
      buyinfo.europe = europe;
      buyinfo.tax = totals.tax;
      buyinfo.subtotal = totals.subtotal;
      buyinfo.totalAmount = totals.total;

      try {
        const response = await fetch(intentGW + "/create-intent", {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
          },
          body: JSON.stringify({
            data: buyinfo,
            token: userinfo.token,
            total: props.total,
          }),
        });

        if (!response.ok) {
          throw new Error("Failed to create payment intent");
        }

        const data = await response.json();
        const clientSecret = data.clientSecret;

        const { error } = await stripe.confirmPayment({
          //`Elements` instance that was used to create the Payment Element
          clientSecret,
          elements,
          confirmParams: {
            return_url: "https://hyperuranium.io/buy",
            payment_method_data: {
              billing_details: {
                name: props.customerName || 'Customer',
                address: {
                  line1: 'N/A',
                  city: 'N/A',
                  country: 'IT',
                  state: 'N/A',
                  postal_code: '00000',
                }
              }
            }
          },
          redirect: "if_required",
        });

        if (error) {
          setErrorMessage(error.message);
          setTimeout(() => {
            setErrorMessage("");
          }, 3000);
          setLoading(0);
          setIsProcessing(false);
        } else {
          // Your customer will be redirected to your `return_url`. For some payment
          // methods like iDEAL, your customer will be redirected to an intermediate
          // site first to authorize the payment, then redirected to the `return_url`.
            setErrorMessage("Paid!");
            setTimeout(() => {
              setStage(stage+1);
            }, 2000);
          
        }
      } catch (error) {
        setErrorMessage(error.message || "Error: 2010");
        setTimeout(() => {
          setErrorMessage("");
        }, 3000);
        setLoading(0);
        setIsProcessing(false);
      }
    };

    const paymentElementOptions = {
      amount: 99999999,
      currency: "eur",
      layout: "tabs",
      paymentMethodOrder: ["card"],
      fields: {
        billingDetails: {
          address: 'never',
        }
      }
    };
    //vasco
    return (
      <>
        <form>
          <PaymentElement options={paymentElementOptions} />
          {/* Show error message to your customers */}
          <div className="h-10 text-xs text-red-500">
          {errorMessage }
        </div>
        </form>

        {!Loading ? (
          <div className="flex align-middle items-center justify-center">
          <span className="mouse2 paybutton " onClick={(e) => handleSubmit()}>
            [ Pay {euro.format(props.total / 100)}]
            </span>
            </div>
        ) : (
          <span className="mouse2 paybutton"> [ Please wait ]</span>
        )}
      </>
    );
  };

  let euro = Intl.NumberFormat("en-DE", {
    style: "currency",
    currency: "EUR",
  });

  function Stage3(props) {
    const [totals] = useState(getTotal);

    useEffect(() => {
      if (!hideNav.left) {
        setHideNav({ left: true, right: false });
      }
    }, []);

    const stripePromise = loadStripe(
      //"pk_live_51NsMC1J4lvUbSAbbUs7YOhEpv2CpVbPjkeklstm7GngjdPCWlJaQIsMgkXgNb6Gax9YAWR5CBsfeQr3dqZCV7tFq003AuPVZgW" // Live
      "pk_test_51SW1wtQrJEge4qHzQQ1iw9MG4CHgfn5zXITJhW511Lb3A8zZb2jfS93O9J8xRUkNtlgRfK2uBEOdZjPx8p2NsnpC00QUsvPgSg" // Sandbox
      
    );
    //vasco

    const options = {
      amount: getTotal().total,
      currency: "eur",
      mode: "payment",
      appearance: {
        /*...*/
      },
    };

    function getTotal() {
      var buyInfo = JSON.parse(sessionStorage.getItem("buyInfo"));

      var ideaCost = parseInt(buyInfo.price);
      var mintCost;
      var subtotal;
      var tax = 0;
      var total;
      var label;
      var walletType =
        sessionStorage.getItem("wallet") === process.env.REACT_APP_OWNWALLET;

      if (walletType) {
        mintCost = parseInt(process.env.REACT_APP_BASE_PRICE_HYP);
        label = "Buy with HyperWallet: ";
      } else {
        mintCost = parseInt(process.env.REACT_APP_BASE_PRICE_OWN);
        label = "";
      }

      subtotal = ideaCost + mintCost;

      // Add Italian VAT (22%) for European users
      if (europe) {
        tax = Math.round(subtotal * 0.22);
      }

      total = subtotal + tax;

      console.log(process.env.REACT_APP_HYPER_FEE)

      return { idea: ideaCost, mint: mintCost, subtotal: subtotal, tax: tax, total: total, label: label };
    }

    return (
      <>
        {totals ? (
          <div className=" flex-row  ">
            <Elements stripe={stripePromise} options={options}>
              <div className="text-xl payinfo flex justify-end">
                <table>
                  <tbody className="text-xl ">
                    {totals.label != "" ?
                    <tr className="border-0 border-red-400">
                      <td>{totals.label}</td>
                      <td>{euro.format(parseInt(totals.mint / 100))}</td>
                    </tr>
                      :
                       null
                       }
                    <tr>
                      <td>Idea : </td>
                      <td> {euro.format(totals.idea / 100)} </td>
                    </tr>
                    {totals.tax > 0 ? (
                      <>
                        <tr>
                          <td>Subtotal : </td>
                          <td>{euro.format(totals.subtotal / 100)}</td>
                        </tr>
                        <tr>
                          <td>VAT (22%) : </td>
                          <td>{euro.format(totals.tax / 100)}</td>
                        </tr>
                      </>
                    ) : null}
                    <tr>
                      <td>Total : </td>
                      <td>{euro.format(totals.total / 100)}</td>
                    </tr>
                  </tbody>
                </table>
              </div>
          
              <CheckoutForm total={getTotal().total} totals={getTotal()} customerName={name} />
            </Elements>
          </div>
        ) : null}
      </>
    );
  }

  function Stage4() {
    var d = JSON.parse(sessionStorage.getItem("buyInfo"));
    return (
      <div className="login">
        Congratulation
        <br />
        you bought the idea!
        <br />
        <br />
        <br />
        <span
          className={
            afterSale.forsale === 1 ? "mouse2 seriesOn" : "mouse2 seriesOff"
          }
          onClick={() => {
            setAfterSale({ newprice: parseFloat(d.price), forsale: 1 });
          }}
        >
          put it for sale
        </span>
        or <br />
        <span
          className={
            afterSale.forsale === 0 ? "mouse2 seriesOn" : "mouse2 seriesOff"
          }
          onClick={() => {
            setAfterSale({ newprice: parseFloat(d.price), forsale: 0 });
          }}
        >
          keep it to yourself
        </span>
      </div>
    );
  }

  function Stage5() {
    var d = JSON.parse(sessionStorage.getItem("buyInfo"));
    return (
      <>
        {afterSale.forsale ? (
          <div>
            <input
              className="email"
              placeholder="new price"
              id="price"
              maxLength="10"
              autoFocus
              onChange={(e) => {
                if (e.target.value === "") e.target.value = 0;
                setAfterSale({
                  forsale: afterSale.forsale,
                  price: parseFloat(e.target.value) * 100,
                });
              }}
              value={
                parseFloat(afterSale.price) / 100
                  ? parseFloat(afterSale.price) / 100
                  : 0
              }
            />
            <br />
            current price
            <br />
            {parseFloat(d.price) / 100} €
          </div>
        ) : (
          setStage(6)
        )}
      </>
    );
  }

  function Stage6() {
    useEffect(() => {
      if (hideNav.left !== false || hideNav.right !== false) {
        setHideNav({ left: false, right: false });
      }
    }, []);

    return (
      <div>
        you can now manage your <br />
        idea at{" "}
        <span
          className="underline mouse2"
          onClick={(e) => openInSameTab("/Listing")}
        >
          the Listing Page{" "}
        </span>
      </div>
    );
  }

  async function handlerAfterSale() {
    var d = JSON.parse(sessionStorage.getItem("buyInfo"));
    var userinfo = getAuthInfo();
    afterSale.id = d.phraseId;
    afterSale.token = userinfo.token;
    afterSale.tokenId = userinfo.id;

    try {
      const response = await authFetch(paymentGW, {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify(afterSale),
      });
      const data = await response.json();
      if (data.name === "TokenExpiredError") {
        logout();
        return;
      }
      if (data.message) {
        setErr(data.message);
        setTimeout(() => {
          setErr("");
        }, 3000);
        return;
      }
      setStage(7);
      setStage(6);
    } catch (error) {
      redirectToLogin();
    }
  }

  function Navigation(props) {
    return (
      <div className="buyfooter">
        <div className="bleft">
          {stage > 2 && stage !== 4 && stage === 5 && (
            <span onClick={(e) => prev()} className="mouse2">
              Prev
            </span>
          )}
        </div>

        <div className="bright">
          {wallet !== "" ? (
            (stage === 2 || (stage < 5 && stage !== 3)) && (
              <span onClick={(e) => next()} className="mouse2">
                Next
              </span>
            )
          ) : (
            <></>
          )}
          {stage === 5 && (
            <span className="mouse2" onClick={(e) => handlerAfterSale()}>
              Save
            </span>
          )}
        </div>
      </div>
    );
  }

  function afterLogin() {
    var d = JSON.parse(sessionStorage.getItem("userinfo"));
    var b = JSON.parse(sessionStorage.getItem("buyInfo"));
    b.BuyerUserId = d.id;
    
    sessionStorage.setItem("buyInfo", JSON.stringify(b));
    sessionStorage.removeItem("wallet");
    setTimeout(() => {
      //setStage(2);
      window.location.reload();
    }, 3000);
  }

  function next() {
    if (stage === 2) {
      setStage(2.5);
    } else if (stage === 2.5) {
      setStage(3);
    } else {
      setStage(stage + 1);
    }
  }

  function prev() {
    if (stage === 2.5) {
      setStage(2);
    } else if (stage === 3) {
      setStage(2.5);
    } else {
      setStage(stage - 1);
    }
  }

  return (
    <div className=" ">
      {stage === 1 && <LoginProcess callback={afterLogin} />}
      {stage === 2 && (
        <div className="buy2">
          <Stage2 />
        </div>
      )}
      {stage === 2.5 && (
        <div className=" ">
          <div className="flex-row text-center border-0">
            <div className="flex">
              <div className="w-1/2">Name:</div>
              <div className="flex-1 text-sm">
                <input
                  id="name"
                  value={name}
                  onChange={(e) => setName(e.target.value)}
                  className="text-2xl w-full"
                />
              </div>
            </div>

                <div className= " flex-row flex border-0 w-full text-lg justify-center">
                <div className=
                  {europe === 1 ? "seriesOn  mouse2 border-2 mr-2" : "  mr-2 seriesOff  mouse2"}   onClick={() => setEurope(1)} >
                Europe
              </div>
              /
              <div className={europe === 0 ? "seriesOn mouse2 ml-2" : "ml-2 seriesOff  mouse2"} onClick={() => setEurope(0)}>
                Rest of the world: 
              </div>
              </div>

            <div className="text-black mt-10 h-10">
              {message }
            </div>

            <div className="buyfooter">
              <div className="bleft">
                <span onClick={(e) => prev()} className="mouse2">
                  Prev
                </span>
              </div>
              <div className="bright">
                { stage === 2.5 && europe != -1 ?
                <span
                  onClick={validateAndNext}
                  className="mouse2"
                >
                  Next
              </span>
                  :
                  null
              }
              </div>
            </div>
          </div>
        </div>
      )}
      {stage === 3 && (
        <div className="flex ">
          <Stage3 idea={idea} buyInfo={sessionStorage.getItem("buyInfo")} />
        </div>
      )}
      {stage === 4 && (
        <div className="buy2">
          <Stage4 />
        </div>
      )}
      {stage === 5 && (
        <div className="buy2">
          <Stage5 />
        </div>
      )}
      {stage === 6 && (
        <div className="buy2">
          <Stage6 />
        </div>
      )}
      {stage > 1 && stage !== 2.5 && <Navigation hideNav={hideNav} />}
    </div>
  );
}

export default BuyProcess;
